import Rellax from "rellax";

export default {
	when() {
		return $('.rellax').length > 0;
	},

	mounted() {
		const rellax = new Rellax('.rellax', {
			breakpoints:[576, 768, 1201]
		});
	},
};
